import React from "react";
import * as s from "./ManagersComponent.styles";

import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

// components
import ManagersControls from "./managersControls/ManagersControls";

const ManagersComponent = (props) => {
  const { showCreateManger } = props;
  const loading = useSelector((state) => state.forAdmins.loading);

  const managers = useSelector((state) => state.forAdmins.admins);
  const isAuthenticated = useSelector((state) => state.auth.role);

  return (
    <s.Container>
      <s.LeadContainer>
        <s.Lead>Managers</s.Lead>
        {showCreateManger && isAuthenticated && (
          <s.CreateBtn
            onClick={() => {
              props.history.push("/create-manager");
            }}
          >
            Create New One
          </s.CreateBtn>
        )}
      </s.LeadContainer>
      <s.ManagersContainer>
        {loading === false && managers.length !== 0 && (
          <ManagersControls managers={managers} />
        )}
      </s.ManagersContainer>
    </s.Container>
  );
};

export default withRouter(ManagersComponent);
